module.exports = __webpack_public_path__ + "public/img/tower20.7345f2b5.png";